import { useRef } from 'react'
import { useToast } from '../../../hooks/toast'
import { Background, ModalWrapper, Button } from './styles'
import IconAlert from '../../../assets/icons/icon-alert-alert.svg'
import pagamento from '../../../api/pagamento'

const DeleteCardModal = ({
  showModal,
  setShowModal,
  setCurrent,
  current,
  cardId,
  setLoading
}) => {
  const modalRef = useRef()
  const { addToast } = useToast()

  const closeModal = (e) => {
    if (modalRef.current === e.target) {
      setShowModal(false)
    }
  }

  const handleMockDeleteCard = async () => {
    setLoading(true)

    await pagamento
      .delCartao(cardId)
      .then((response) => {
        if (response) setLoading(false)

        if (response.ok) {
          addToast({
            type: 'success',
            title: 'Cartão excluído'
          })
        } else if (response.status !== 200) {
          setLoading(false)
          addToast({
            type: 'error',
            title: 'Erro ao excluir Cartão'
          })
        }
      })
      .catch((error) => {
        if (error) setLoading(false)
        addToast({
          type: 'error',
          title: 'Erro ao excluir Cartão',
          description: `${error}`
        })
      })
    current === 1 ? setCurrent(3) : setCurrent(1)
    setShowModal(false)
  }

  return (
    <>
      {showModal ? (
        <Background onClick={closeModal}>
          <ModalWrapper>
            <div className="title">
              <h2 className="modal-title">Remover Cartão</h2>
            </div>
            <p className="modal-description">Deseja remover este cartão?</p>
            <div className="button-container">
              <Button onClick={handleMockDeleteCard}>Remover</Button>
              <Button
                className="button-outline"
                onClick={() => setShowModal((prev) => !prev)}
              >
                Cancelar
              </Button>
            </div>
          </ModalWrapper>
        </Background>
      ) : null}
    </>
  )
}

export default DeleteCardModal
